import type { TFunction } from 'i18next';
import type { OrderStep } from '@/types/supervisor';

export interface CanvasStepConfig {
  readonly id: OrderStep;
  readonly labelKey: string;
  readonly defaultLabel: string;
}

export const CANVAS_STEP_CONFIG: ReadonlyArray<CanvasStepConfig> = [
  { id: 'upload', labelKey: 'canvas.steps.upload', defaultLabel: 'Upload' },
  { id: 'uploadedImages', labelKey: 'canvas.steps.uploadedImages', defaultLabel: 'Files' },
  { id: 'size', labelKey: 'canvas.steps.size', defaultLabel: 'Size' },
  { id: 'paper', labelKey: 'canvas.steps.paper', defaultLabel: 'Paper' },
  { id: 'printer', labelKey: 'canvas.steps.printer', defaultLabel: 'Printer' },
  { id: 'frame', labelKey: 'canvas.steps.frame', defaultLabel: 'Frame' },
  { id: 'review', labelKey: 'canvas.steps.review', defaultLabel: 'Order' },
  { id: 'address', labelKey: 'canvas.steps.address', defaultLabel: 'Address' },
  { id: 'payment', labelKey: 'canvas.steps.payment', defaultLabel: 'Payment' },
  { id: 'done', labelKey: 'canvas.steps.done', defaultLabel: 'Order list' },
];

export const getCanvasStepLabel = (t: TFunction, step: OrderStep | undefined): string => {
  const config = CANVAS_STEP_CONFIG.find(current => current.id === step);
  if (!config) {
    return t('canvas.steps.unknown', 'In progress');
  }
  return t(config.labelKey, config.defaultLabel);
};
